export abstract class SnackbarConstants {

    static readonly DURATION_DISMISS_SHORT = { duration: 3000 }
    
    static readonly DURATION_DISMISS_LONG = { duration: 7000 }

    static readonly DURATION_DISMISS_ALIVE = { duration: 0 }

    static readonly ACTION_DISMISS = 'Dismiss'
  }